
import { Coordinates } from "../models";

export function getCoordinates(geoposition: GeolocationPosition | GeolocationPositionError): Coordinates {

    function isGeoposition(pos: GeolocationPosition | GeolocationPositionError): pos is GeolocationPosition {
        return pos && (<GeolocationPosition>pos).coords !== undefined;
    }

    return isGeoposition(geoposition) ? {
        longitude: geoposition.coords.longitude,
        latitude: geoposition.coords.latitude,
        accuracy: geoposition.coords.accuracy
    } : null;
}


